import api from './api';

// 🔒 FRONTEND DUPLICATE PREVENTION SERVICE
class DuplicateCheckService {
  
  // Real-time PAN duplicate check
  static async checkPanDuplicate(pan, excludeId = null) {
    try {
      const params = { pan: pan.toUpperCase() };
      if (excludeId) params.excludeId = excludeId;
      
      const response = await api.get('/investors/check-pan', { params });
      return response.data;
    } catch (error) {
      console.error('PAN duplicate check failed:', error);
      return { exists: false, valid: false, message: 'Check failed' };
    }
  }

  // Real-time Email duplicate check
  static async checkEmailDuplicate(email, excludeId = null) {
    try {
      const params = { email: email.toLowerCase() };
      if (excludeId) params.excludeId = excludeId;
      
      const response = await api.get('/investors/check-email', { params });
      return response.data;
    } catch (error) {
      console.error('Email duplicate check failed:', error);
      return { exists: false, valid: false, message: 'Check failed' };
    }
  }

  // Real-time Folio format validation
  static async checkFolioFormat(folio) {
    try {
      const response = await api.get('/investors/check-folio', { params: { folio } });
      return response.data;
    } catch (error) {
      console.error('Folio format check failed:', error);
      return { valid: false, message: 'Check failed' };
    }
  }

  static debounce(func, delay) {
    let timeoutId;
    let pendingResolve;
    return (...args) => {
      if (pendingResolve) pendingResolve({ exists: false, valid: false, message: 'Cancelled' });
      return new Promise((resolve) => {
        pendingResolve = resolve;
        clearTimeout(timeoutId);
        timeoutId = setTimeout(async () => {
          pendingResolve = null;
          try {
            const result = await func.apply(this, args);
            resolve(result);
          } catch (e) {
            resolve({ exists: false, valid: false, message: 'Error' });
          }
        }, delay);
      });
    };
  }

  // Create debounced versions
  static debouncedPanCheck = this.debounce(this.checkPanDuplicate, 500);
  static debouncedEmailCheck = this.debounce(this.checkEmailDuplicate, 500);
  static debouncedFolioCheck = this.debounce(this.checkFolioFormat, 500);
}

export default DuplicateCheckService;
